<template>
  <div>
    <!-- One time -->
    <div>
      <p class="text-muted mb-2">One time Fees</p>
      <fee-table :data="getOneTimeFees(data)"/>
    </div>
    <!-- Recurring -->
    <div>
      <p class="text-muted mb-2">Recurring Fees</p>
      <fee-table :data="getRecurringFees(data)"/>
    </div>
  </div>
</template>
<script>
import moment from 'moment'

import { find } from 'lodash'
import FeeTable from './partials/FeeTable'

export default {

  name: 'ReportFees',
  components: {
    FeeTable,
  },
  props: {
    data: {
      type: Array,
      default: () => [],
    },
  },
  data: function() {
    return {
    }
  },
  methods: {
    moment,
    find,
    getOneTimeFees(data) {
      const oneTime = data.filter(element => element.fee_type === 1)
      return oneTime
    },
    getRecurringFees(data) {
      const recurring = data.filter(element => element.fee_type !== 1)
      return recurring
    },
  },
}
</script>
